import React, { useEffect, useRef } from 'react'
import { useFocusByProp } from '../Core/useFocusByProp'

const NavLink = ({
    item,
    hasFocus= false,
    handleKeyDown,
    handleOnFocus
}) => {
    const [itemRef] = useFocusByProp(hasFocus)

    const onKeyDown = event => {
        if(event.key === ' ' || event.keyCode == 32) {
            itemRef.current.click()
        } else if(handleKeyDown)  {
            handleKeyDown(event)
        }
    } 

    const addProps = {
        ...item.ariaActive && {'aria-current': 'page'}
    }

    return (
        <a 
            className='access-main-link text-medium-navigation access-typo' 
            href={item.url} 
            ref={itemRef}
            onKeyDown={onKeyDown}
            onFocus={handleOnFocus}
            {...addProps}
        >
                {item.title}
        </a>
    )
}

export default NavLink